import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@adc/ui-core'
import classNames from 'classnames/bind'
import cls from './styles.scss'

const cx = classNames.bind(cls)

const OfferBadge = ({ size = 'small', className, ...rest }) => (
  <Text
    size={size}
    weight='heavy'
    color='white'
    className={cx(
      'offer-badge',
      'u-pt-1',
      'u-pb-1',
      'u-pr-2',
      'u-pl-2',
      'u-display-ib',
      className
    )}
    {...rest}
  >
    Direct Offer
  </Text>
)

OfferBadge.propTypes = {
  size: Text.propTypes.size,
  className: PropTypes.string,
}

export default OfferBadge
